// @flow

import { format } from "date-fns"
import { List } from "immutable"

import type { SeatingFromServer } from "booking/services/additionalServices/services/seating/types"
import Journey from "common/records/Journey"
import jsonFetch from "common/services/fetch/jsonFetch"
import type Options from "common/records/Options"
import formatTimestamptToISO from "common/utils/formatTimestampToISO"
import Flight from "common/records/Flight"
import type { PassengerFields } from "booking/scenes/ReservationForm/services/fields/passengersFields"
import { getPrices, getAdultsPrice } from "booking/services/prices/reducer"

type CheckAncillariesResponse = {
  seating?: ?SeatingFromServer,
  // TODO: Add other services from response
  mandatory_seating?: any,
}

export const parsePassengers = (
  passengers: PassengerFields,
): { birthday: string, category: string }[] =>
  // $FlowFixMe
  passengers.map(p => {
    const year = p.birthYear || {}
    const month = p.birthMonth || {}
    const day = p.birthDay || {}
    const category = p.category || ""
    return {
      birthday: format(new Date(`${year}/${month}/${day}`), "YYYY-MM-DD"),
      category,
    }
  })

export const parseItinerary = (flights: List<Flight>) =>
  flights.map(f => ({
    source: f.src,
    destination: f.dst,
    departure: formatTimestamptToISO(f.dtime_utc),
    arrival: formatTimestamptToISO(f.atime_utc),
    carrier: {
      operating: {
        code: f.operating_airline.iata,
      },
    },
    vehicle: {
      type: f.vehicle.type,
    },
    is_hidden: f.is_hidden,
    segment_code: f.id,
    carrier_segment_code: f.flight_no,
  }))

const checkAncillaries = (
  state: any,
  journey: Journey,
  passengers: PassengerFields,
  options: Options,
  // optional argument to specify which ancillaries you need. Currently used just for seating
  ancillaries?: ?Array<string> = undefined,
): CheckAncillariesResponse => {
  const [{ fees }, { currency }] = [getPrices(state), getAdultsPrice(state)]
  const servicePrice = Number(fees.get("allFees") - fees.get("merchantFee"))
  const body = {
    booking: {
      price: {
        tickets: {
          amount: String(
            Number(fees.get("baseFare") + fees.get("merchantFee") + servicePrice).toFixed(2),
          ),
          base: String(fees.get("baseFare")),
          currency: currency.toUpperCase(),
          merchant: String(fees.get("merchantFee")),
          service: String(servicePrice.toFixed(2)),
          service_flat: "0",
        },
      },
    },
    passengers: parsePassengers(passengers).filter(pap => pap.birthday !== "Invalid Date"),
    itinerary: parseItinerary(journey.get("_original").flights),
  }
  const resolvedBody = Array.isArray(ancillaries) ? { ...body, ancillaries } : body
  if (body.passengers.length > 0) {
    return jsonFetch(`${options.get("bookingApiUrl")}/check_ancillaries`, {
      method: "POST",
      body: resolvedBody,
    })
  }
  return Promise.resolve({})
}

export default checkAncillaries
